<template>
    <b-container fluid>
        <b-row class="mb-4">
            <b-col cols="12">
                <b-card>
                    <template #header>
                        <div class="d-flex justify-content-between">
                            <h5>1. 교체 대상 결과보고서 조회 및 선택</h5>
                        </div>
                    </template>
                    <b-row>
                        <b-col cols="12">
                            {{ replacement_target_searchForm }}
                        </b-col>
                        <b-col cols="6" md="3" xl="3">
                            <b-form-group id="fieldset-company-id" label="company-id" label-for="input-company-id">
                                <b-form-input id="input-company-id" v-model="replacement_target_searchForm.company_id"
                                              :disabled="is_replacement_global_disabled" trim />
                            </b-form-group>
                        </b-col>
                        <b-col cols="6" md="3" xl="3">
                            <b-form-group id="fieldset-history-id" label="history-id" label-for="input-history-id">
                                <b-form-input id="input-history-id" v-model="replacement_target_searchForm.history_id"
                                              :disabled="is_replacement_global_disabled" trim />
                            </b-form-group>
                        </b-col>
                        <b-col cols="6" md="3" xl="2">
                            <b-form-group id="fieldset-report-mode" label="report-mode" label-for="input-report-mode">
                                <b-form-select id="input-report-mode"
                                               v-model="replacement_target_searchForm.report_mode" :options="[
                                        { value: null, text: '미선택' },
                                        { value: 'DOC', text: '서면평가' },
                                        { value: 'OSIS', text: '실사평가' }
                                    ]" :select-size="3" :disabled="is_replacement_global_disabled" multiple />
                            </b-form-group>
                        </b-col>
                        <b-col cols="6" md="3" xl="2">
                            <b-form-group id="fieldset-confirmed" label="confirmed" label-for="input-confirmed">
                                <b-form-select id="input-confirmed" v-model="replacement_target_searchForm.confirmed"
                                               :options="[
                                        { value: null, text: '미선택' },
                                        { value: true, text: '확정' },
                                        { value: false, text: '미확정' }
                                    ]" :select-size="3" :disabled="is_replacement_global_disabled" multiple />
                            </b-form-group>
                        </b-col>
                        <b-col cols="6" md="3" xl="2">
                            <b-form-group id="fieldset-timestamp" label="timestamp" label-for="input-timestamp">
                                <b-form-input id="input-timestamp" v-model="replacement_target_searchForm.time_stamp"
                                              :disabled="is_replacement_global_disabled" trim />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row class="mb-3">
            <b-col cols="12" md="4">
                <b-card header="2. 교체 언어 및 교체 대상 리소스 선택" class="h-100">
                    <!-- <DropdownLanguage /> -->
                    <div class="d-flex">
                        <div>
                            교체 언어 선택
                            <dropdown-language :lang="globalReportOpt.language" :disabled="is_replacement_global_disabled"
                                               @updateLang="(lang) => updateLang(lang, 'language')"
                            />    
                        </div>
                        
                        <div>
                            교체 대상 선택
                            <dropdown-language :lang="globalReportOpt.submit_lang" :disabled="is_replacement_global_disabled"
                                               @updateLang="(lang) => selectTargetFromLang(lang, 'submit_lang')"
                            />
                        </div>
                       
                    </div>
                </b-card>
            </b-col>
            <b-col cols="12" md="4">
                <b-card header="3. 교체 대상 히스토리 조회" class="h-100">
                    <b-btn-group>
                        <b-btn size="sm"
                               :disabled="is_replacement_global_disabled"
                               @click="searchReplacementHistoryTarget"
                        >
                            교체대상 보고서 조회
                        </b-btn>
                        <b-btn size="sm" variant="danger"
                               :disabled="is_replacement_global_disabled"
                               @click="initializeReportSearchForm"
                        >
                            조회 조건 초기화
                        </b-btn>
                    </b-btn-group>
                </b-card>
            </b-col>
            <b-col cols="12" md="4">
                <b-card header="4. 대상 히스토리 교체" class="h-100">

                    <b-form-checkbox v-model="is_overwriting_parent_vendor_campaign">
                        대체평가 기업의 캠페인을 원래 평가 캠페인으로 교체
                    </b-form-checkbox>
                    <!-- 건마다 브라우저 다운로드가 일어나 쌓이므로 기본은 끔 -->
                    <b-form-checkbox v-model="save_local" :disabled="is_replacement_global_disabled">
                        교체한 PDF 내려받기 (건마다 1개)
                    </b-form-checkbox>
                    <b-btn size="sm" :disabled="!replacement_history.length || is_replacement_global_disabled"
                           @click="confirmReplacement">
                        결과보고서 교체
                    </b-btn>
                    <b-btn v-if="is_running_replacement && replacement_total" size="sm" variant="outline-danger" class="ml-2"
                           :disabled="is_replacement_cancel_requested" @click="is_replacement_cancel_requested = true">
                        {{ is_replacement_cancel_requested ? '현재 건 이후 중단 중...' : '교체 중단' }}
                    </b-btn>
                </b-card>
            </b-col>
        </b-row>
        <!-- <b-row class="mb-3">
            <b-col cols="12">
                
            </b-col>
        </b-row> -->
        <b-row>
            <b-col cols="12" class="mb-3">
                <b-card no-body>
                    <template #header>
                        <div class="d-flex justify-content-between">
                            <h5 class="mb-0">결과보고서 히스토리</h5>
                            <b-form-select v-model="reports_PerPage" :options="[
                                { value: 10, text: '10개씩 보기' },
                                { value: 20, text: '20개씩 보기' },
                                { value: 30, text: '30개씩 보기' },
                                { value: 40, text: '40개씩 보기' },
                                { value: 50, text: '50개씩 보기' }
                            ]" size="sm" class="w-auto" />
                        </div>
                    </template>

                    <div class="p-3">
                        <b-card no-body>
                            <div class="border-bottom p-3">
                                <div class="mb-2">
                                    <div class="d-flex justify-content-between">
                                        <h6>
                                            교체진행 대상 Report ID:
                                            (총 {{ replacement_history.length }}개)
                                        </h6>

                                        <div>
                                            <span>교체진행 History ID:
                                                {{ report_is_running_replacement_target_history_id || '없음' }}</span>
                                            <span class="mx-2">/</span>
                                            <span>교체진행 기업 ID: {{ progress_company_id || '없음' }}</span>
                                        </div>
                                    </div>

                                    <b-form-input :value="replacement_history.join(',')" />
                                </div>
                                <b-progress :value="replacement_total ? (progress_num / replacement_total) * 100 : 0" :min="0" :max="100"
                                            show-progress animated></b-progress>
                            </div>
                            <div class="p-3">
                                <div v-if="replacement_total">진행: {{ progress_num }} / {{ replacement_total }}건</div>
                                <div>교체 실패 히스토리:
                                    <template v-if="!fail_history_list.length">없음</template>
                                    <div v-for="fail in fail_history_list" :key="`fail-${fail.id}`" class="text-danger">
                                        #{{ fail.id }} {{ fail.company_name }}: {{ fail.reason }}
                                    </div>
                                </div>
                                <div v-if="warn_history_list.length">교체됨 (경고):
                                    <div v-for="warn in warn_history_list" :key="`warn-${warn.id}`" class="text-warning">
                                        #{{ warn.id }} {{ warn.company_name }}: {{ warn.reason }}
                                    </div>
                                </div>
                            </div>
                        </b-card>
                    </div>

                    <b-table-simple id="replacement-report-table"
                                    :per-page="reports_PerPage"
                                    :current-page="reports_CurrentPage"
                                    class="border-bottom"
                                    responsive
                    >
                        <b-tr>
                            <b-th>No.</b-th>
                            <b-th>보고서 Id</b-th>
                            <b-th>프로젝트 코드</b-th>
                            <b-th>캠페인 ID</b-th>
                            <b-th>기업 ID</b-th>
                            <b-th>평가유형</b-th>
                            <b-th style="width:170px;">Report Key</b-th>
                            <b-th style="width:100px;">생성일</b-th>
                            <b-th>확정여부</b-th>
                            <b-th>Action</b-th>
                        </b-tr>

                        <template v-for="(report, report_idx) in reports">
                            <template v-if="report.priority">
                                <b-tr :key="`report-${report.priority.id}-priority-company_id-${report.priority.company_id}-${report_idx}`"
                                      :class="[{ 'bg-tealgray300': (
                                        report.priority && replacement_history.includes(report.priority.id)
                                        ||
                                        replacement_history.includes(report.id))
                                    }]"
                                >
                                    <b-td rowspan="2" class="border-right align-middle">
                                        {{ report_idx + 1 }}
                                    </b-td>
                                    <b-td>
                                        <b-badge variant="dark">대체</b-badge>
                                        {{ report.priority.id }}
                                    </b-td>
                                    <b-td>
                                        <b-badge variant="dark">대체</b-badge>
                                        {{ report.priority.project_code }}
                                    </b-td>
                                    <b-td>
                                        <b-badge variant="dark">대체</b-badge>
                                        {{ report.priority.campaign_id }}
                                    </b-td>
                                    <b-td>
                                        <b-badge variant="dark">대체</b-badge>
                                        {{ report.priority.company_id }}
                                        ({{ report.priority.vendor_code }})
                                        <div>
                                            {{ report.priority.company_name }}
                                        </div>
                                    </b-td>
                                    <b-td>
                                        {{ report.priority.mode }}
                                    </b-td>
                                    <b-td style="word-break: break-all;">
                                        <template v-if="report.priority.report_key">
                                            <b-link @click="viewReport(report.priority)"
                                            >
                                                {{ report.priority.report_name.replace("2024_HMG_Supplier_ESG_Assessment_Report_", '') }}
                                            </b-link>
                                        </template>
                                        <template v-else>
                                            <div class="text-center">
                                                -
                                            </div>
                                        </template>
                                    </b-td>
                                    <b-td>
                                        {{ formatDate(report.priority.time_stamp, 'YYYY-MM-DD HH:mm') }}
                                    </b-td>
                                    <b-td>
                                        <template v-if="report.priority.confirmed !== null">
                                            <!-- {{ report.confirmed }} -->
                                            <b-badge :variant="report.priority.confirmed ? 'primary' : 'danger'">
                                                {{ report.priority.confirmed ? '확정' : '미확정' }}
                                            </b-badge>
                                        </template>
                                        <template v-else>
                                            <div class="text-center"> - </div>
                                        </template>
                                    </b-td>
                                    <b-td>
                                        <b-badge variant="dark">대체</b-badge>
                                        <b-form-checkbox v-model="replacement_history"
                                                         :value="report.priority.id"
                                                         :unchecked-value="null"
                                        >
                                            교체하기
                                        </b-form-checkbox>
                                    </b-td>
                                </b-tr>
                            </template>

                            <b-tr v-if="report.company_id !== null"
                                  :key="`report-${report.id}-company_id-${report.company_id}-${report_idx}`"
                                  :class="[{ 'bgray-200': !report.id }]"
                            >
                                <template v-if="!report.priority">
                                    <b-td>
                                        {{ report_idx + 1 }}
                                    </b-td>
                                </template>
                                <b-td>
                                    <template v-if="report.id">
                                        {{ report.id }}
                                    </template>
                                    <template v-else>
                                        <div class="text-center"> - </div>
                                    </template>
                                </b-td>
                                <b-td>
                                    <template v-if="report.project_code">
                                        {{ report.project_code }}
                                    </template>
                                    <template v-else>
                                        <div class="text-center"> - </div>
                                    </template>
                                </b-td>
                                <b-td>
                                    <template v-if="report.campaign_id">
                                        {{ report.campaign_id }}
                                    </template>
                                    <template v-else>
                                        <div class="text-center"> - </div>
                                    </template>
                                </b-td>
                                <b-td>
                                    <template v-if="report.company_id">
                                        {{ report.company_id }}
                                        ({{ report.vendor_code }})

                                        <div>
                                            {{ report.company_name }}
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="text-center"> - </div>
                                    </template>
                                </b-td>
                                <b-td>
                                    <template v-if="report.mode">
                                        {{ report.mode }}
                                    </template>
                                    <template v-else>
                                        <div class="text-center"> - </div>
                                    </template>
                                </b-td>
                                <b-td style="word-break: break-all;">
                                    <!-- {{ report.report_key || ' - ' }} -->
                                    <template v-if="report.report_key">
                                        <b-link @click="viewReport(report)"
                                        >
                                            {{ report.report_name.replace("2024_HMG_Supplier_ESG_Assessment_Report_", '') }}
                                        </b-link>
                                    </template>
                                    <template v-else>
                                        <div class="text-center"> - </div>
                                    </template>
                                </b-td>
                                <b-td>
                                    <template v-if="report.time_stamp">
                                        {{ formatDate(report.time_stamp, 'YYYY-MM-DD HH:mm') }}
                                    </template>
                                    <template v-else>
                                        <div class="text-center"> - </div>
                                    </template>
                                </b-td>
                                <b-td>
                                    <template v-if="report.confirmed !== null">
                                        <!-- {{ report.confirmed }} -->
                                        <b-badge :variant="report.confirmed ? 'primary' : 'danger'">
                                            {{ report.confirmed ? '확정' : '미확정' }}
                                        </b-badge>
                                    </template>
                                    <template v-else>
                                        <div class="text-center"> - </div>
                                    </template>
                                </b-td>
                                <b-td>
                                    <b-form-checkbox
                                        :ref="`checkbox-report-${report.id}`"
                                        v-model="replacement_history"
                                        :value="report.id"
                                        :unchecked-value="null"
                                        :disabled="report.id === null"
                                    >
                                        교체하기
                                    </b-form-checkbox>
                                </b-td>
                            </b-tr>
                        </template>
                    </b-table-simple>

                    <b-pagination v-model="reports_CurrentPage" aria-controls="replacement-report-table"
                                  :total-rows="reports.length" :per-page="reports_PerPage"
                                  :disabled="is_replacement_global_disabled" class="mb-3" align="center">
                    </b-pagination>

                </b-card>

            </b-col>
        </b-row>
        <BulkReportContainer v-if="reportData"
                             ref="reportViewer"
                             style="opacity: 1"
                             :report_lang="globalReportOpt.language"
                             :reportData="reportData"
                             :pdf_filename="pdf_filename"
                             :reportMode="reportMode"
                             :assessmentType="replacement_target_searchForm.report_mode?.[0] || 'DOC'"
                             :is_reassessment="globalReportOpt.is_reassessment"
                             :set_actual_duration="globalReportOpt.is_actual_duration"
        >

        </BulkReportContainer>
    </b-container>
</template>

<script>
import axios from 'axios';
import { getErrorMessage } from '@core/utils/api/errorMessage';
import ReportCommonMixin from '@shared_mixins/report/report.hmc.mixin';
import ReportTranslationMixin from '@shared_mixins/report/report.translation.mixin.js';
import ReportNamingMixin from '@shared/mixin/report/report.naming.mixin';
import AssessmentCommonMixin from '@shared/mixin/assessment.common.mixin';
import ReportCoreMixin from '@shared/mixin/report/report.core.mixin';
import dropdownLanguage from '@shared/components/utils/dropdown-language.vue';
import BulkReportContainer from '@shared/components/admin/components/report/ReportMamagement/BulkReportContainer.vue';
import {waitTime} from '@shared/utils/common';

export default {
    name: 'ReplacementReport',
    components: {BulkReportContainer, dropdownLanguage},
    mixins: [
        ReportNamingMixin,
        AssessmentCommonMixin,
        {
            methods: {
                addFontVFS: ReportCoreMixin.methods.addFontVFS,
                generatePDFfilename: ReportCoreMixin.methods.generatePDFfilename
            }
        }
    ],
    data() {
        return {
            is_loaded_reports: false,
            progress_num: 0,
            replacement_total: 0,
            is_replacement_cancel_requested: false,
            progress_company_id: null,
            globalReportOpt: {
                project_code: null,
                campaign_id: null,
                report_mode: null,
                language: 'ko',
                submit_lang: 'ko',
                is_reassessment: false,
                is_actual_duration: false,
                generate_report: false,
                confirm_report: false,
                release_report: false,
                report_name: '',
                auto_report_name: true
            },
            reports: [],
            reports_field: [
                {
                    key: 'id',
                    label: 'History Id',
                    sortable: true
                },
                {
                    key: 'project_code',
                    label: '프로젝트 코드',
                    sortable: true
                },
                {
                    key: 'campaign_id',
                    label: '캠페인 ID',
                    sortable: true
                },
                {
                    key: 'company_id',
                    label: '기업 ID',
                    sortable: true
                },
                {
                    key: 'mode',
                    label: '평가유형',
                    sortable: true
                },
                {
                    key: 'report_key',
                    label: 'Report Key',
                    sortable: true,
                    tdClass: ['f-85']
                },
                {
                    key: 'time_stamp',
                    label: '생성일',
                    sortable: true,
                    tdClass: ['f-85']
                },
                {
                    key: 'confirmed',
                    label: '확정여부',
                    sortable: true
                },
                {
                    key: 'action',
                    label: '',
                    sortable: false
                },
            ],
            replacement_target_resource: null,
            replacement_target_searchForm: {
                company_id: null,
                history_id: null,
                report_mode: [],
                confirmed: [],
                time_stamp: null
            },
            replacement_history: [],
            reports_CurrentPage: 1,
            reports_PerPage: 20,

            is_running_replacement: false,
            report_is_running_replacement_target_history_id: null,

            reportMode: 'full',
            // is_rendering_report_component: false,
            request_report: false,
            pdf_filename: null,
            selected_report_mode: 'full',
            selected_assessment_type: null,
            reportData: {
                info: null,
                benchmarks: null,
                parser: null,
                risk: null,
                scoring: null
            },
            fail_history_list: [],
            // 교체는 됐지만 로고 같은 장식이 빠진 보고서
            warn_history_list: [],
            is_overwriting_parent_vendor_campaign: false,
            save_local: false,

            // 결과보고서 번역 관련 데이터
            // audit_comment, review_message 에 있는 삭제대상 auditor shorname prefix 리스트
            auditor_shortname_prefix: [
                '김수헌', '(유광)', 'chj', 'dy', 'fy', 'fy;', 'hu', 'js', 'sh', '권강미',
                '강민정(240729)', '강민정(240731)', '강민정(240604)', '강민정(240605)', '강민정(240607)', '강민정(240610)', '강민정(240612)', '강민정(240731)',
                '김동영', '김현서', '성정민', '우대위', '이승주', '이종미', '이효지진',
                '이효진', '허은채', '.허은채', '허은채(240614)', '허은채(240618)'
            ],
            duplicate_audit_message: {}
        };
    },
    computed: {
        is_replacement_global_disabled() {
            return !this.is_loaded_reports || this.is_running_replacement;
        },
        auditor_shortname_prefix_regexp() {
            // return new RegExp(`(${this.auditor_shortname_prefix.map(word => word + ':?\\s*').join('|')})`, 'g');
            return new RegExp(`(${this.auditor_shortname_prefix.map(word => word + '\\s*:?\\s*').join('|')})`, 'g');
        },
        project_code(){
            return this.$route.query.pc || this.$route.query.project_code;
        },
    },
    watch: {
        is_replacement_global_disabled(_disabled_state) {
            this.$emit('prevent-close-replacement-modal', _disabled_state);
        },
        'report_lang': {
            async handler(_aft, _bef) {
                this.is_running_replacement = true;
                this.$emit('prevent-close-report-modal', true);

                // this.report_lang = _aft

                // if (_aft === "ca") {
                //     this.jsPDFOpt.tableOpt.th.font.font = this.jsPDFOpt.fontFamily_ca
                //     this.jsPDFOpt.tableOpt.td.font.font = this.jsPDFOpt.fontFamily_ca
                // } else {
                //     this.jsPDFOpt.tableOpt.th.font.font = this.jsPDFOpt.fontFamily
                //     this.jsPDFOpt.tableOpt.th.font.font = this.jsPDFOpt.fontFamily
                // }

                if (_bef !== _aft) {
                    await this.addFontVFS();
                    // this.$nextTick(() => {
                    //     this.previewPDF()
                    // })

                    this.initializeReport();
                }

                this.is_running_replacement = false;
                this.$emit('prevent-close-report-modal', false);
            }
        }
    },
    async created() {
        this.is_loaded_reports = false;
        const _res_reports = await this.$axios('/report/history', {
            params: {
                project_code: this.project_code,
                with_alt: true
            }
        });
        let _reports = _res_reports.data.result.sort((company_a, company_b) => {
            company_a = company_a.priority ? company_a.priority : company_a;
            company_b = company_b.priority ? company_b.priority : company_b;
            return new Date(company_a.id) - new Date(company_b.id);
        });


        console.log(' ~ _reports => ', _reports);


        this.reports = _reports;
        this.is_loaded_reports = true;
    },
    mounted() { },
    methods: {
        searchReplacementHistoryTarget() {
            this.is_running_replacement = true;
            let {
                company_id: replacement_company_id,
                history_id: replacement_history_id,
                report_mode: replacement_report_mode,
                time_stamp: replacement_time_stamp,
                confirmed: replacement_confirmed,
            } = this.replacement_target_searchForm;

            if (replacement_history_id) {
                replacement_history_id = replacement_history_id.trim().split(',').map(h_id => Number(h_id));
            } else {
                replacement_history_id = [];
            }

            if (replacement_company_id) {
                replacement_company_id = replacement_company_id.trim().split(',').map(c_id => Number(c_id));
            } else {
                replacement_company_id = [];
            }

            const _replacement_history = this.reports.filter(report => {
                let _is_included = true;
                if (_is_included && replacement_company_id.length) {
                    _is_included = replacement_company_id.includes(report.company_id) || (report.priority && replacement_company_id.includes(report.priority.company_id));
                }

                if (_is_included && replacement_history_id.length) {
                    _is_included = replacement_history_id.includes(report.id) || (report.priority && replacement_history_id.includes(report.priority.id));
                }

                if (_is_included && replacement_report_mode.length) {
                    _is_included = replacement_report_mode.includes(report.mode) || (report.priority && replacement_report_mode.includes(report.priority.mode));
                }

                if (_is_included && replacement_confirmed.length) {
                    _is_included = replacement_confirmed.includes(report.confirmed) || (report.priority && replacement_confirmed.includes(report.priority.confirmed));
                }

                if (_is_included && replacement_time_stamp) {
                    _is_included = replacement_time_stamp === this.formatDate(report.time_stamp) || (report.priority && replacement_time_stamp === this.formatDate(report.priority.time_stamp));
                }

                if (_is_included) return report;
            });

            if (!_replacement_history.length) {
                this.replacement_history = [];
            } else {
                this.replacement_history = _replacement_history.map(({ id, priority }) => priority ? priority.id : id);
            }
            this.is_running_replacement = false;
        },
        initializeReportSearchForm () {
            this.replacement_target_searchForm = {
                company_id: null,
                history_id: null,
                report_mode: [],
                confirmed: [],
                time_stamp: null
            };

            this.replacement_history = [];
        },
        // 이미 협력사에게 보이는(확정) 보고서 파일을 덮어쓰므로 시작 전에 건수와 복구 불가를 알린다
        async confirmReplacement () {
            const _targets = this.reports.filter(({ id, priority }) => this.replacement_history.includes(priority ? priority.id : id));
            const _confirmed_cnt = _targets.filter(({ confirmed, priority }) => (priority ? priority.confirmed : confirmed)).length;
            const h = this.$createElement;
            const _ok = await this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: '결과보고서 교체',
                message: h('div', {}, [
                    h('div', {}, `선택한 결과보고서 ${this.replacement_history.length}건의 파일(PDF, JSON)을 덮어씁니다.`),
                    h('div', {}, `그중 확정된 보고서: ${_confirmed_cnt}건 (이미 협력사에게 배포된 보고서가 포함될 수 있습니다)`),
                    h('div', {class: 'text-danger'}, '덮어쓴 파일은 복구할 수 없습니다. 건당 약 40초 이상 걸리며, 중단하면 현재 건까지만 처리됩니다.'),
                    h('div', {}, '진행하시겠습니까?')
                ])
            });
            if (_ok) this.replacementReport();
        },
        async replacementReport () {
            this.is_running_replacement = true;
            this.progress_num = 0;
            this.is_replacement_cancel_requested = false;
            this.fail_history_list = [];
            this.warn_history_list = [];
            console.log('replacementReport ~ ');

            const _total_replacement_start_time = performance.now();
            console.log(`결과보고서 총교체 시작시간: ${this.formatTime(_total_replacement_start_time)}`);

            // if (!this.replacement_target_resource) {
            //     alert("'3. 교체 대상 리소스 선택'을 선택해주세요")
            //     return false
            // }

            if (!this.replacement_history.length) {
                this.is_running_replacement = false;
                this.$showModal({
                    type: 'alert',
                    state: 'warning',
                    title: '교체 대상 없음',
                    message: '선택된 교체 대상 Report가 없습니다.'
                });
                return false;
            }

            try {
                await this.addFontVFS();
            } catch (e) {
                // 준비 단계 실패로 is_running_replacement 가 고착되면 모달 X 버튼까지 숨는다
                console.error(e);
                this.is_running_replacement = false;
                this.$EventBus.$emit('toast-failure', '결과보고서 교체 실패', '교체 준비 중 오류가 발생했습니다. 다시 시도해주세요.');
                return false;
            }
            
            const _replacement_target_reports = this.replacement_history.reduce((_replacement_target_reports, _history_id) => {
                const _report_history = this.reports.find(({ id, priority }) => (id === _history_id || (priority && priority.id === _history_id)));
                if (_report_history) _replacement_target_reports.push(_report_history);
                return _replacement_target_reports;
            }, []);
            console.log(' ~ _replacement_target_reports => ', _replacement_target_reports);

            console.log(' ~~~~~~~~~~~~~~~~~~~~~~~~~ Bulk 교체 시작 ~~~~~~~~~~~~~~~~~~~~~~~~~ ');
            let _accumulated_ele_replacement_time = 0;
            this.replacement_total = _replacement_target_reports.length;
            if (_replacement_target_reports.length) {
                this.is_running_replacement = true;

                for (const [report_idx, report_history] of _replacement_target_reports.entries()) {
                    if (this.is_replacement_cancel_requested) break;
                    console.log(' ~ report_history => ', report_history);

                    const report = report_history.priority ? report_history.priority : report_history;

                    console.log(` ~~~~~~~~~~~~ 교체: ${report_idx + 1}번 / ${_replacement_target_reports.length} 개 ~~~~~~~~~~~~ `);
                    const _ele_replacement_begin_time = performance.now(); // 작업 시작 전 시간 기록
                    console.log(`  ~ 결과보고서 교체 시작시간: ${this.formatTime(_ele_replacement_begin_time)}`);
                    try {
                        console.log(`   ~ report.id => ${report.id} // report.company_id => ${report.company_id}`);
                        console.log('   ~ report => ', report);
                        this.report_is_running_replacement_target_history_id = report.id;
                        this.progress_company_id = report.company_id;

                        const _res_report_score_set = await axios.get(`https://${process.env.VUE_APP_S3_BUCKET_NAME}.s3.${process.env.VUE_APP_S3_REGION_NAME}.amazonaws.com/${report.report_key}.json`);
                        const report_score_set = _res_report_score_set.data;
                        console.log('      ~ report_score_set => ', report_score_set);
                        console.log('      ~ report_score_set?.scoring && report_score_set?.scoring?.scoring_pd.length => ', report_score_set?.scoring && report_score_set?.scoring?.scoring_pd.length);


                        if (report_score_set?.scoring && report_score_set?.scoring?.scoring_pd.length) {

                            // for (const [ev_idx, ev] of report_score_set.scoring.scoring_pd.entries()) {
                            //     // if (ev.audit_comment && /^[^\p{L}\p{N}]+$/u.test(ev.audit_comment) === false) {
                            //     if (!this.isFieldEmpty(ev.audit_comment)) {
                            //         let _audit_comment = ev.audit_comment
                            //         if (this.auditor_shortname_prefix_regexp.test(_audit_comment)) {
                            //             _audit_comment = _audit_comment.replace(this.auditor_shortname_prefix_regexp, '').trim()
                            //         }

                            //         if (this.duplicate_audit_message[_audit_comment]) {
                            //             ev.review_comment_ca = this.duplicate_audit_message[_audit_comment]['ca']
                            //             ev.review_comment_ea = this.duplicate_audit_message[_audit_comment]['ea']
                            //         } else {
                            //             const _res_translation = await this.$axios.get('/translate', {
                            //                 params: { text: _audit_comment, target_lang: 'ea,ca' }
                            //             })

                            //             if (!this.duplicate_audit_message[_audit_comment]) {
                            //                 this.duplicate_audit_message[_audit_comment] = _res_translation.data
                            //             }
                            //         }
                            //     } else if (!ev.audit_comment && (ev.audit_comment_ca || ev.audit_comment_ea)) {
                            //         ev.audit_comment_ca = null
                            //         ev.audit_comment_ea = null
                            //     }

                            //     // if (ev.review_comment  && /^[^\p{L}\p{N}]+$/u.test(ev.review_comment) === false) {
                            //     if (!this.isFieldEmpty(ev.review_comment)) {
                            //         let _review_comment = ev.review_comment
                            //         if (this.auditor_shortname_prefix_regexp.test(_review_comment)) {
                            //             _review_comment = _review_comment.replace(this.auditor_shortname_prefix_regexp, '').trim()
                            //         }

                            //         if (this.duplicate_audit_message[_review_comment]) {
                            //             ev.review_comment_ca = this.duplicate_audit_message[_review_comment]['ca']
                            //             ev.review_comment_ea = this.duplicate_audit_message[_review_comment]['ea']
                            //         } else {
                            //             const _res_translation = await this.$axios.get('/translate', {
                            //                 params: { text: _review_comment, target_lang: 'ca,ea' }
                            //             })

                            //             if (!this.duplicate_audit_message[_review_comment]) {
                            //                 this.duplicate_audit_message[_review_comment] = _res_translation.data
                            //             }
                            //         }
                            //     } else if (!ev.review_comment && (ev.review_comment_ca || ev.review_comment_ea)) {
                            //         ev.review_comment_ca = null
                            //         ev.review_comment_ea = null
                            //     }
                            // }

                            console.log(` ~ this.is_overwriting_parent_vendor_campaign => ${this.is_overwriting_parent_vendor_campaign}`);

                            if (this.is_overwriting_parent_vendor_campaign && report_history.priority) {
                                report_score_set.info.campaign.id = report_history.campaign_id;
                                report_score_set.info.campaign.campaign_name = report_history.campaign_name;
                                // 캠페인을 덮어썼으므로 원본 캠페인의 렌더러 스냅샷은 무효 —
                                // 제거해서 재업로드 JSON 이 stale 키를 갖지 않게 하고, 판정은 새 campaign_id 의 env 폴백
                                // (또는 서버가 DB 행 스냅샷을 재주입하는 백엔드 계약 §2.4)에 맡긴다.
                                delete report_score_set.report_meta;
                            }


                            console.log('      ~~~~~ 갱신 결과보고서 생성 시작');
                            this.reportData = {
                                info: report_score_set.info,
                                benchmarks: report_score_set.benchmarks,
                                parser: report_score_set.parser_result,
                                risk: report_score_set.risk,
                                scoring: report_score_set.scoring,
                                report_meta: report_score_set.report_meta
                            };
                            console.log('         ~ 1. this.reportData => ', this.reportData);


                            this.pdf_filename = this.generatePDFfilename(this.replacement_target_searchForm.report_mode?.[0] || 'DOC');
                            console.log('         ~ 2. 결과보고서 이름 생성 => ', this.pdf_filename);

                            await waitTime(1000);
                            console.log('         ~ 4. generatePDF 메서드 실헹 ');
                            const doc = await this.$refs.reportViewer.generatePDF();

                            console.log('         ~ 5. 결과보고서 blob 변환 ');
                            if (this.save_local) {
                                doc.save(`${this.project_code} - ${this.pdf_filename}.pdf`);
                            }
                            // 렌더러가 그리다 실패한 부분은 예외 없이 빠지고 문서에 이름만 붙는다(report.core.mixin.js addRenderWarning).
                            // 교체하면 협력사·원청사가 받는 파일이 바뀌므로 고객이 받는 내용이 빠졌으면 이 건은 교체하지 않는다. 로고 같은 장식은 경고로만 남긴다.
                            if (doc.render_warnings && doc.render_warnings.length) {
                                throw new Error(`빠진 부분: ${doc.render_warnings.join(', ')}. 교체하지 않았습니다.`);
                            }
                            const pdfBlobData = doc.output('blob', {
                                filename: `${this.pdf_filename}.pdf`
                            });
                            console.log('            ~ pdfBlobData => ', pdfBlobData);

                            console.log('         ~ 6. 결과보고서 PDF 교체');
                            const pdfFileObj = new File([pdfBlobData], `${this.pdf_filename}.pdf`, { type: 'application/pdf' });
                            const PDFformData = new FormData();
                            PDFformData.append('history_id', report.id);
                            PDFformData.append('report', pdfFileObj, `${this.pdf_filename}.pdf`);

                            await this.$axios.post('/admin/override-report-file',
                                PDFformData,
                                { headers: { 'Content-Type': 'multipart/form-data' } }
                            );
                            console.log('            ~ 결과보고서 교체 완료!');
                            await waitTime(15000);


                            console.log('         ~ 6. 결과보고서 JSON 교체 ');
                            const RawReportScoreSet = JSON.stringify(report_score_set);
                            const RawReportScoreBlob = new Blob([RawReportScoreSet], { type: 'application/json' });
                            const JSONFormData = new FormData();
                            JSONFormData.append('history_id', report.id);
                            JSONFormData.append('raw_report', RawReportScoreBlob, `${this.pdf_filename}.json`);

                            await this.$axios.post('/admin/override-report-raw-file',
                                JSONFormData,
                                { headers: { 'Content-Type': 'multipart/form-data' } }
                            );
                            console.log('                       ~ 결과보고서 JSON 완료!');
                            // await waitTime(20000);
                            if (doc.render_decor_warnings && doc.render_decor_warnings.length) {
                                this.warn_history_list.push({
                                    id: report.id,
                                    company_name: report.company_name,
                                    reason: `빠진 부분: ${doc.render_decor_warnings.join(', ')}`
                                });
                            }
                            
                            
                        }
                    } catch (error) {
                        if (error.response) {
                            console.log('       ~ error.response => ', error.response);
                        } else {
                            console.log('       ~ error => ', error);
                            console.log('       ~ error.message => ', error.message);
                        }
                        this.fail_history_list.push({
                            id: report.id,
                            company_name: report.company_name,
                            reason: getErrorMessage(error, error.message || '알 수 없는 오류')
                        });
                    } finally {
                        const _ele_replacement_end_time = performance.now(); // 작업 시작 전 시간 기록
                        const _ele_replacement_replacement_time = _ele_replacement_end_time - _ele_replacement_begin_time;
                        _accumulated_ele_replacement_time += _ele_replacement_replacement_time;
                        console.log(`      ~ 결과보고서 교체 종료시간: ${this.formatTime(_ele_replacement_end_time)}`);
                        console.log(`        ~ 결과보고서 교체 소요시간: ${this.formatTime(_ele_replacement_replacement_time)}`);
                        console.log(`   ~ 결과보고서 교체 누적 소요시간: ${this.formatTime(_accumulated_ele_replacement_time)}`);


                        this.reportData = {
                            info: null,
                            benchmarks: null,
                            parser: null,
                            risk: null,
                            scoring: null
                        };
                        this.pdf_filename = null;
                        this.progress_num += 1;
                        await waitTime(25000); // buffer 시간;
                    }
                }
            }

            const _total_replacement_end_time = performance.now();
            console.log(`총 교체 종료시간: ${this.formatTime(_total_replacement_end_time)}`);
            console.log(`총 교체 소요시간: ${this.formatTime(_total_replacement_end_time - _total_replacement_start_time)}`);


            this.is_running_replacement = false;
            this.is_replacement_cancel_requested = false;
        },
        formatTime(ms) {
            const milliseconds = Math.floor(ms % 1000);
            const seconds = Math.floor((ms / 1000) % 60);
            const minutes = Math.floor((ms / (1000 * 60)) % 60);
            const hours = Math.floor(ms / (1000 * 60 * 60));

            return `${hours}h ${minutes}m ${seconds}s ${milliseconds}ms`;
        },
        async viewReport (_report) {
            const _res_report_block = await axios.get(`https://${process.env.VUE_APP_S3_BUCKET_NAME}.s3.${process.env.VUE_APP_S3_REGION_NAME}.amazonaws.com/${_report.report_path}`, {
                responseType: 'blob'
            });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([_res_report_block.data], { type: 'application/pdf' }));
            link.setAttribute('download', _report.report_name);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        updateLang(lang, key) {
            this.report_lang = lang
            this.globalReportOpt[key] = lang;
        },
        selectTargetFromLang(lang, key) {
            this.globalReportOpt[key] = lang;
            this.replacement_history = [];
            const mapLang = {
                ko: '_KOR',
                en: '_ENG',
                ca: '_CHI'
            };
            this.reports.forEach((item)=>{
                const re = new RegExp(`${mapLang[lang]}(?:[0-9.-]|$)`, 'i');
                if(re.test(item.report_name)) {
                    this.replacement_history.push(item.id);
                    this.$refs[`checkbox-report-${item.id}`].value = true;


                }
            });
        }
    }
};
</script>

<style></style>
